module.exports = __webpack_public_path__ + "static/media/introduce_p1.c7d9ceba.png";